import { render, staticRenderFns } from "./UploadPopper.vue?vue&type=template&id=f89ff622&scoped=true"
import script from "./UploadPopper.vue?vue&type=script&lang=js"
export * from "./UploadPopper.vue?vue&type=script&lang=js"
import style0 from "./UploadPopper.vue?vue&type=style&index=0&id=f89ff622&prod&lang=scss&scoped=true"
import style1 from "./UploadPopper.vue?vue&type=style&index=1&id=f89ff622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89ff622",
  null
  
)

export default component.exports